
import { formatSummary } from "./utils/ProfileUtils";

interface CandidateSummaryProps {
  summary?: string;
}

export const CandidateSummary = ({ summary }: CandidateSummaryProps) => {
  const formattedSummary = formatSummary(summary);
  
  if (!formattedSummary) return null;
  
  return (
    <div className="mb-6">
      <p className="text-gray-700 whitespace-pre-line">
        {formattedSummary}
      </p>
    </div>
  );
};
